import { BibleReadDayChapter} from '../models/bible-read-day-chapter';

export class Biblereadcurrentday {
  PlanStatus : boolean;
  IdBibleReadPlan: number;
  NoChapters: number;
  CurrentDay: number;
  BibleReadDayChapters: BibleReadDayChapter = new BibleReadDayChapter();
}
